import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-shared-account-dialog',
  template: `
    <div class="header">
    <div class="icon">
      <img src="/images/login/shared-account-icon.svg" alt="icon">
    </div>
    </div>
    <h3 class="title">{{ 'oeapp.accountSharing.title' | translate }}</h3>
    <div class="body">{{ 'oeapp.accountSharing.paragraph' | translate }}</div>
    <button class="close-button btn btn-accent-contained" (click)="close()">{{ 'lcFeedback.cta' | translate }}</button>
  `,
  styleUrls: ['./shared-account-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SharedAccountDialogComponent {

  constructor(private readonly ngbActiveModal: NgbActiveModal) { }

  public close(): void {
    this.ngbActiveModal.close();
  }

}



// WEBPACK FOOTER //
// ./ts/app/login/shared-account-dialog/shared-account-dialog.component.ts